export default __webpack_public_path__ + "static/media/cooperation.0e119100.jpg";